<mat-list class="search-menu-sort common-search-menu {{viewName}}">
  @for (s of sortOrderMenus; track $index) {
    <button
      mat-menu-item
      [ngClass]="{'active':searchContainer.getOrder() === s[AConst.ORDER]}"
    >
      <mat-radio-button
        [checked]="searchContainer.getOrder() === s[AConst.ORDER]"
        [value]="s[AConst.ORDER]"
        (click)="changeSortOrder(s)"
        (keydown)="null"
      >
        <span class="common-search-menu__radio-text">
          {{ s.description | translate }}
        </span>
      </mat-radio-button>
    </button>
  }
</mat-list>
